<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">凭证汇总表</span>
		</div>
		<div class="margin-right-left margin-top no-print">
			<account-date-choose v-model="accountDate"/>
			<span class="range-sep">至</span>
			<DatePicker type="month" v-model="endMonth" format="YYYY-MM" placeholder="结束月份(可选)" :clearable="true" style="width: 130px; vertical-align: middle;"></DatePicker>
			<div class="float-right">
				<Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
				<Button icon="fa fa-filter" @click="openFilter">筛选</Button>
				<Button icon="fa fa-refresh" :loading="loading" @click="loadList">刷新</Button>
				<Button icon="fa fa-download" @click="doExport">导出</Button>
				<Button icon="fa fa-print" @click="doPrint">打印</Button>
			</div>
		</div>
		<div class="h-panel-body" type="flex" :space-x="10">
			<div class="print-header">
				<div class="print-title">凭证汇总表</div>
				<div class="print-sub">
					<span class="print-company">编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
					<span>期间：{{periodText}}</span>
					<span class="print-unit">单位：元</span>
				</div>
			</div>
			<table class="balance" v-if="!showNumPrice">
				<thead class="header">
				<tr>
					<td rowspan="2" v-width="100">科目编码</td>
					<td rowspan="2" v-width="200">科目名称</td>
					<td colspan="2">金额合计</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<template v-for="(item, index) in dataList">
					<tr v-if="item.code == null" :key="index" class="total-row">
						<td colspan="2" align="center"><b>{{item.name}}</b></td>
						<td align="right"><b>{{item.currentDebitAmount|numFormat}}</b></td>
						<td align="right"><b>{{item.currentCreditAmount|numFormat}}</b></td>
					</tr>
					<tr v-else :key="index">
						<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
						<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover primary-color" @click="goDetail(item)">{{item.name}}</span></td>
						<td align="right">{{item.currentDebitAmount|numFormat}}</td>
						<td align="right">{{item.currentCreditAmount|numFormat}}</td>
					</tr>
				</template>
				<tr v-if="!dataList.length">
					<td colspan="4" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
			<table class="balance" v-else>
				<thead class="header">
				<tr>
					<td rowspan="2" v-width="100">科目编码</td>
					<td rowspan="2" v-width="200">科目名称</td>
					<td rowspan="2" v-width="100">计量单位</td>
					<td colspan="2">金额合计</td>
					<td colspan="2">数量合计</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<template v-for="(item, index) in dataList">
					<tr v-if="item.code == null" :key="index" class="total-row">
						<td colspan="3" align="center"><b>{{item.name}}</b></td>
						<td align="right"><b>{{item.currentDebitAmount|numFormat}}</b></td>
						<td align="right"><b>{{item.currentCreditAmount|numFormat}}</b></td>
						<td align="right"><b>{{item.currentDebitAmountNum|numFormat}}</b></td>
						<td align="right"><b>{{item.currentCreditAmountNum|numFormat}}</b></td>
					</tr>
					<tr v-else :key="index">
						<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
						<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover primary-color" @click="goDetail(item)">{{item.name}}</span></td>
						<td class="text-center">{{item.unit}}</td>
						<td align="right">{{item.currentDebitAmount|numFormat}}</td>
						<td align="right">{{item.currentCreditAmount|numFormat}}</td>
						<td align="right">{{item.currentDebitAmountNum|numFormat}}</td>
						<td align="right">{{item.currentCreditAmountNum|numFormat}}</td>
					</tr>
				</template>
				<tr v-if="!dataList.length">
					<td colspan="7" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
		<Modal v-model="showFilter">
			<div slot="header">筛选</div>
			<Form :label-width="90">
				<FormItem label="起始科目">
					<Select v-model="filterForm.startSubjectCode" :datas="subjectOptions" keyName="code" titleName="title" filterable placeholder="请选择起始科目"></Select>
				</FormItem>
				<FormItem label="结束科目">
					<Select v-model="filterForm.endSubjectCode" :datas="subjectOptions" keyName="code" titleName="title" filterable placeholder="请选择结束科目"></Select>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="resetFilter">重置</Button>
				<Button @click="showFilter=false">取消</Button>
				<Button color="primary" @click="applyFilter">确定</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import {mapState} from 'vuex';
	import moment from 'moment';
	import {exportCsv} from '../../js/common/export-file';

	export default {
		name: "SubjectSummary",
		data() {
			return {
				dataList: [],
				accountDate: null,
				endMonth: null,
				showNumPrice: false,
				loading: false,
				showFilter: false,
				subjectOptions: [],
				filterForm: {
					startSubjectCode: null,
					endSubjectCode: null
				},
				appliedFilter: {
					startSubjectCode: null,
					endSubjectCode: null
				}
			}
		},
		computed: {
			...mapState(['currentAccountSets']),
			periodText() {
				if (!this.accountDate) {
					return '';
				}
				let s = moment(this.accountDate).format('YYYY年第MM期');
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('第MM期');
				}
				return s;
			}
		},
		watch: {
			accountDate() {
			this.loadList();
		},
		endMonth() {
			this.loadList();
		},
		showNumPrice() {
			this.loadList();
		}
		},
		methods: {
			loadList() {
				this.loading = true;
				let params = {
					accountDate: this.accountDate,
					showNumPrice: this.showNumPrice,
					startSubjectCode: this.appliedFilter.startSubjectCode,
					endSubjectCode: this.appliedFilter.endSubjectCode
				};
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
				}
				this.$api.accountbook.loadSubjectSummary(params).then(({data}) => {
					this.dataList = data;
				}).finally(() => {
					this.loading = false;
				})
			},
			loadSubjects() {
				this.$api.setting.subject.allList().then(({data}) => {
					this.subjectOptions = (data || []).map(s => ({code: s.code, title: s.code + ' ' + s.name}));
				});
			},
			openFilter() {
				this.filterForm = Object.assign({}, this.appliedFilter);
				this.showFilter = true;
			},
			applyFilter() {
				if (this.filterForm.startSubjectCode && this.filterForm.endSubjectCode
					&& this.filterForm.startSubjectCode > this.filterForm.endSubjectCode) {
					this.$Message.error('起始科目不能大于结束科目');
					return;
				}
				this.appliedFilter = Object.assign({}, this.filterForm);
				this.showFilter = false;
				this.loadList();
			},
			resetFilter() {
				this.filterForm = {startSubjectCode: null, endSubjectCode: null};
				this.appliedFilter = {startSubjectCode: null, endSubjectCode: null};
				this.showFilter = false;
				this.loadList();
			},
			doExport() {
				if (!this.dataList.length) {
					this.$Message.error('暂无数据可导出');
					return;
				}
				let headers, rows;
				if (!this.showNumPrice) {
					headers = ['科目编码', '科目名称', '借方金额', '贷方金额'];
					rows = this.dataList.map(item => [item.code, item.name, item.currentDebitAmount, item.currentCreditAmount]);
				} else {
					headers = ['科目编码', '科目名称', '计量单位', '借方金额', '贷方金额', '借方数量', '贷方数量'];
					rows = this.dataList.map(item => [item.code, item.name, item.unit, item.currentDebitAmount, item.currentCreditAmount, item.currentDebitAmountNum, item.currentCreditAmountNum]);
				}
				exportCsv('凭证汇总表-' + moment(this.accountDate).format('YYYYMM') + (this.endMonth ? '-' + moment(this.endMonth, 'YYYY-MM').format('YYYYMM') : ''), headers, rows);
			},
			doPrint() {
				window.print();
			},
			//联查：跳转明细账并定位到该科目，携带当前期间
			goDetail(item) {
				if (!item.code) {
					return;
				}
				let query = {
					subjectCode: item.code,
					accountDate: moment(this.accountDate).format('YYYY-MM-DD')
				};
				if (this.endMonth) {
					query.endMonth = this.endMonth;
				}
				this.$router.push({name: 'DetailedAccounts', query});
			}
		},
		mounted() {
			this.loadSubjects();
		}
	}
</script>

<style scoped lang="less">
	.range-sep {
		margin: 0 8px;
		line-height: 30px;
		vertical-align: middle;
	}
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}

</style>
